import { UtilityBar } from "@/components/organisms/UtilityBar";

export function TaxCodesSubnav() {
  return (
    <>
      <UtilityBar />
    </>
  );
}
